import { connect } from 'react-redux';
import NewsPageComponent from '../components/NewsPageComponent';
import { getNewsCategoryIfNeeded } from '../actions/NewsActions';
import { getNewsArchivePage } from '../actions/NewsArchiveActions';

const mapStateToProps = (state) => ({
    archivePages: state.news.archivePages,
    newsCategories: state.news.newsCategories,
});

export default connect(mapStateToProps, { getNewsArchivePage, getNewsCategoryIfNeeded })(NewsPageComponent);
